import { NotificationTemplateTable } from 'features/notification/components/notification-list-table/template-table';
import { NotificationTopBarTemplate } from 'features/notification/components/top-bar/notification-template-top-bar';
import { NotificationTemplateFilterFormValues, NotificationTemplateFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetTemplate } from 'features/notification/use-cases/get-template';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: NotificationTemplateFilterFormValues = {
    Id: undefined,
    Title: undefined,
    TitleAr:undefined,
    ContentEn: undefined,
    ContentAr:undefined,
    Image:undefined,
    ImageAr:undefined,
    ImageUrl:undefined,
    AnnouncementType: undefined,
    templateId:null,
    TemplateName:undefined,
    RedirectionUrl:undefined,
    ImageUrlAr:undefined,
    
};


export const TemplateViewList = () => {
    // const [filterValue, setFilterValue] = useState(getInitialFilterValues);
    const { params, updateParams, resetPage } =
        usePaginationParams<NotificationTemplateFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',
            ...getInitialFilterValues,
        });


    const { data, refetch, isFetching } = useGetTemplate(params, { retry: false });
    const handleFiltersChange = (values: NotificationTemplateFilterFormValues) => {
        // setFilterValue(values);
        updateParams(values);
        resetPage();
        refetch();
    };

    return (
        <>
          
            <NotificationTopBarTemplate
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
                refetch={refetch}
            />
            
            <NotificationTemplateTable
                isUsersListLoading={isFetching}
                typeReportList={data?.items as any}
                itemsCount={data?.total as number}
                tableParams={params}
                refetch={refetch}
                updateParams={updateParams}
            />
            <Outlet />
        </>
    );
};
